import React from 'react';
import { BaseEdge, EdgeLabelRenderer, getStraightPath } from 'reactflow';
import { Button } from './ui/button';
import { X } from 'lucide-react';

/**
 * Custom Orthogonal Edge Component
 * Creates clean 90-degree angle connections between tables
 * Automatically routes based on handle positions (top, right, bottom, left)
 */
export const CustomOrthogonalEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  data,
  markerEnd,
  selected
}) => {
  /**
   * Create clean horizontal orthogonal path
   * Simplified for left-right connections only
   */
  const createOrthogonalPath = () => {
    let path = `M ${sourceX} ${sourceY}`;
    
    // Calculate midpoint for horizontal routing
    const midX = (sourceX + targetX) / 2;
    
    // Create Z-shaped path with 90-degree angles
    if (sourcePosition === 'right' && targetPosition === 'left') {
      // Source di kiri, target di kanan: right → left
      path += ` L ${midX} ${sourceY} L ${midX} ${targetY} L ${targetX} ${targetY}`;
    } else if (sourcePosition === 'left' && targetPosition === 'right') {
      // Source di kanan, target di kiri: left → right
      path += ` L ${midX} ${sourceY} L ${midX} ${targetY} L ${targetX} ${targetY}`;
    } else {
      // Fallback: straight line
      path += ` L ${targetX} ${targetY}`;
    }
    
    return path;
  };

  const edgePath = createOrthogonalPath();
  
  // Calculate label position at the midpoint
  const labelX = (sourceX + targetX) / 2;
  const labelY = (sourceY + targetY) / 2;

  const handleDelete = (event) => {
    event.stopPropagation();
    if (data?.onDelete) {
      data.onDelete(id);
    }
  };

  return (
    <>
      {/* Invisible thick path for easier selection */}
      <path
        d={edgePath}
        fill="none"
        strokeWidth={20}
        stroke="transparent"
        className="react-flow__edge-interaction"
      />
      
      {/* Visible edge path */}
      <path
        id={id}
        style={style}
        className={`react-flow__edge-path transition-all duration-200 ${
          selected ? 'drop-shadow-lg' : ''
        }`}
        d={edgePath}
        markerEnd={markerEnd}
        fill="none"
        strokeWidth={selected ? 3 : 2}
      />
      {selected && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              fontSize: 12,
              pointerEvents: 'all',
            }}
            className="nodrag nopan"
          >
            <Button
              data-testid={`delete-edge-${id}`}
              size="icon"
              variant="destructive"
              className="h-6 w-6 rounded-full shadow-lg hover:-translate-y-[1px] transition-transform duration-200"
              onClick={handleDelete}
              title="Hapus Relasi"
            >
              <X className="w-3 h-3" strokeWidth={2} />
            </Button>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};
